import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Wallet, MessageSquare, TrendingUp, Grid } from 'lucide-react';

const TABS = [
  { label: 'Home',   path: '/dashboard',   icon: LayoutDashboard },
  { label: 'Budget', path: '/budget',      icon: Wallet },
  { label: 'Chanakya', path: '/chatbot',     icon: MessageSquare },
  { label: 'Invest', path: '/investments', icon: TrendingUp },
  { label: 'More',   path: '/more',        icon: Grid },
];

export default function BottomTabBar() {
  const location = useLocation();
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 md:hidden bg-white dark:bg-stone-900 border-t border-stone-200 dark:border-stone-800 flex items-stretch">
      {TABS.map((tab) => {
        const Icon = tab.icon;
        const active = location.pathname === tab.path;
        return (
          <Link key={tab.path} to={tab.path}
            className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 font-semibold transition-colors
              ${active ? 'text-orange-500' : 'text-stone-400 dark:text-stone-500'}`}>
            <Icon size={20} strokeWidth={active ? 2.5 : 1.8} />
            <span className={tab.label === 'Chanakya' ? 'text-[9px]' : 'text-[10px]'}>{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
